import React, { useEffect, useState } from "react";
import { PlayCircle, Home } from "lucide-react";
import api from "../../lib/api";
import { EmptyState, openOnboarding } from "./EmptyState";
import { EMPTY, WIZARD } from "../../content/onboardingTexts";

export const OnboardingBanner = () => {
  const [s, setS] = useState(null);
  useEffect(() => {
    const load = () => api.get("/onboarding/state").then((r) => setS(r.data)).catch(() => {});
    load();
    window.addEventListener("onboarding-closed", load);
    return () => window.removeEventListener("onboarding-closed", load);
  }, []);
  if (!s) return null;
  if (s.has_example) return (
    <div className="flex flex-wrap items-center gap-3 bg-amber-50 border border-amber-200 text-amber-900 rounded-2xl px-5 py-4" data-testid="demo-banner">
      <p className="flex-1 text-sm"><b>Vous êtes en mode exemple.</b> Le bien « Exemple — T2 Lyon 3e », son locataire, son bail et 3 quittances sont fictifs.</p>
      <button onClick={async () => { await api.delete("/onboarding/demo"); setS({ ...s, has_example: false }); window.dispatchEvent(new Event("onboarding-closed")); openOnboarding(s.has_property ? 0 : 1); }}
        className="px-4 py-2 rounded-full bg-brand-greenDeep text-white text-sm font-semibold" data-testid="demo-delete-btn">Supprimer l'exemple et créer mon bien</button>
    </div>
  );
  if (!s.has_property) return <EmptyState icon={Home} title={EMPTY.dashboard.title} cta={EMPTY.dashboard.cta} demo onCta={() => openOnboarding(1)} testid="empty-dashboard" />;
  const w = s.wizard || {};
  if (w.status === "active" && !s.has_lease && w.step > 0) return (
    <div className="flex flex-wrap items-center gap-3 bg-brand-greenDeep text-white rounded-2xl px-5 py-4" data-testid="onboarding-resume-banner">
      <PlayCircle className="w-6 h-6 text-brand-lime shrink-0" />
      <p className="flex-1 text-sm">{WIZARD.resume} <span className="text-white/60">Étape {Math.min(w.step, 3)}/3</span></p>
      <button onClick={() => openOnboarding(w.step)} className="px-4 py-2 rounded-full bg-brand-lime text-brand-greenDeep text-sm font-semibold" data-testid="onboarding-resume-btn">Reprendre la configuration</button>
    </div>
  );
  return null;
};
